export default __webpack_public_path__ + "static/media/resume.3c7c97f5.pdf";